import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// DOCS: https://redux-toolkit.js.org/rtk-query/api/fetchBaseQuery

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://api.lobsterlaw.com/',
    prepareHeaders: (headers, { getState }) => {
      // const state = getState()
      // console.log('prepareHeaders state', state)
      // console.log('prepareHeaders headers', headers)
      // console.log('Setting headers')
      headers.set('authorization', `Bearer FAKEFAKEFAKE`)
      // console.log('prepareHeaders headers2', headers)

      // const token = getState().auth.token

      // If we have a token set in state, let's assume that we should be passing it.
      // if (token) {
        // headers.set('authorization', `Bearer ${token}`)
      // }

      return headers
    }
  }),
  tagTypes: ['DUMMY', 'MATTER', 'CLIENT', 'AI_DATA', 'ME'],
  keepUnusedDataFor: 1,
  endpoints: (builder) => ({
    getMe: builder.query({
      query: () => '/me',
      providesTags: ['ME'],
    }),
    getDummy: builder.query({
      query: () => '/dummy_data',
      providesTags: ['DUMMY'],
    }),
    getMatters: builder.query({
      query: () => '/v1/matters',
      providesTags: ['MATTER'],
    }),
    getPayments: builder.query({
      query: () => '/v1/payments',
      providesTags: ['PAYMENT'],
    }),
    getClients: builder.query({
      // query: () => '/badclients',
      query: () => '/clients',
      // providesTags: ['CLIENT'],
      providesTags: (result, error, id) => [{ type: 'CLIENT', id }],
      transformResponse: (response, meta, arg) => {
        // return response
        if (!response["_metadata"].success_flag) {
          throw Error(response["_metadata"].error_message)
        }
        return response.data
        // return ["ABC", "DEF"]
        // throw Error('BOOM')
      },
    }),
    getAIData: builder.query({
      query: (new_ai_query) => ({
        url: '/v1/ai/email',
        // url: '/fake/500',
        // url: '/fake_ai_data',
        method: 'POST',
        body: new_ai_query,
      }),
      providesTags: ['AI_DATA'],
      transformResponse: (response, meta, arg) => {
        // return response
        if (!response["_metadata"].success_flag) {
          throw Error(response["_metadata"].error_message)
        }
        console.log('getAIData: response.data', response.data)
        return response.data.ai_result
        // return ["ABC", "DEF"]
        // throw Error('BOOM')
      },
    }),
    // getMatter: builder.query({
    //   query: (matter_id) => `/matters/${matter_id}`,
    //   providesTags: ['MATTER'],
    // }),
    // getPost: builder.query({
    //   query: (postId) => `/posts/${postId}`,
    // }),
    // addNewPost: builder.mutation({
    //   query: (initialPost) => ({
    //     url: '/posts',
    //     method: 'POST',
    //     body: initialPost,
    //   }),
    //   invalidatesTags: ['Post'],
    // }),
    // addNewDummy: builder.mutation({
    //   query: (new_dummy_data) => ({
    //     url: '/dummy_data',
    //     method: 'POST',
    //     body: new_dummy_data,
    //   }),
    //   invalidatesTags: ['DUMMY'],
    // }),
  }),
})

export const {
  useGetMeQuery,
  useGetDummyQuery,
  useGetMattersQuery,
  useGetPaymentsQuery,
  useGetClientsQuery,
  useLazyGetAIDataQuery,
  // useGetPostsQuery,
  // useGetPostQuery,
  // useAddNewPostMutation,
  useAddNewDummyMutation,
} = apiSlice
